import { render, staticRenderFns } from "./DiscussContent.vue?vue&type=template&id=d31f09d6&scoped=true"
import script from "./DiscussContent.vue?vue&type=script&lang=js"
export * from "./DiscussContent.vue?vue&type=script&lang=js"
import style0 from "./DiscussContent.vue?vue&type=style&index=0&id=d31f09d6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31f09d6",
  null
  
)

export default component.exports